import Header from "../Dishboard/Header";
import React from "react";

function Home() {
  return (
    <div>
      <Header />
      <section>
        <h1>Getting Started with React and TypeScript</h1>
      </section>
    </div>
  );
}

export default Home;
